export const FETCH_WEATHER_REQUEST_LOCATION = "FETCH_WEATHER_REQUEST_LOCATION";
export const FETCH_WEATHER_REQUEST = "FETCH_WEATHER_REQUEST";
export const FETCH_WEATHER_SUCCESS = "FETCH_WEATHER_SUCCESS";
export const FETCH_WEATHER_FAILURE = "FETCH_WEATHER_FAILURE";

export const CLEAR_STORE = "CLEAR_STORE";
export const SET_ERROR = "SET_ERROR";
